<div class="wsheet" data-id="sheet" aria-hidden="true">

  <div class="wsheet__scrim" data-id="scrim"></div>

  <section class="wsheet__panel" role="dialog" aria-modal="true" aria-label="<%= _lcs( 'Wetter und Vorhersage' ) %>">

    <div class="wsheet__grip" data-id="grip"></div>

    <header class="wsheet__head">
      <div class="wsheet__head-text">
        <h2 class="wsheet__title"><%= title %></h2>
        <p class="wsheet__sub"><%= subtitle %></p>
      </div>
      <button class="wsheet__close iconbtn" type="button" data-id="close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <!-- Either entry point can reach the other view without closing the sheet. -->
    <div class="wtabs" role="tablist">
      <button class="wtab<%= 'hours' === mode ? ' wtab--active' : '' %>" type="button"
              role="tab" aria-selected="<%= 'hours' === mode %>" data-mode="hours"><%= _lcs( 'Stündlich' ) %></button>
      <button class="wtab<%= 'forecast' === mode ? ' wtab--active' : '' %>" type="button"
              role="tab" aria-selected="<%= 'forecast' === mode %>" data-mode="forecast"><%= _lcs( '7 Tage' ) %></button>
    </div>

    <div class="wsheet__body">

      <% if ( current ) { %>
      <!-- Right now -->
      <div class="wnow">
        <i class="icon icon--<%= current.icon %> wnow__icon"></i>
        <div class="wnow__text">
          <div class="wnow__temp"><%= current.temp %></div>
          <div class="wnow__label"><%= current.label %></div>
        </div>
      </div>
      <% } %>

      <% if ( 'hours' === mode ) { %>

        <% if ( hours.length ) { %>
        <!-- Hour-by-hour, scrolling sideways; rolls past midnight. -->
        <div class="section-head"><h3><%= _lcs( 'Stündlich' ) %></h3></div>
        <div class="whours">
          <% hours.forEach( function( h ) { %>
            <% if ( h.dayBreak ) { %>
              <div class="whours__break" aria-hidden="true"><span><%= h.dayBreak %></span></div>
            <% } %>
            <div class="whour<%= h.isNow ? ' whour--now' : '' %>">
              <span class="whour__time"><%= h.time %></span>
              <i class="icon icon--<%= h.icon %> whour__icon" title="<%= h.label %>"></i>
              <span class="whour__temp"><%= h.temp %></span>
              <span class="whour__rain"><% if ( h.rain ) { %><i class="icon icon--umbrella"></i><%= h.rain %><% } %></span>
            </div>
          <% } ); %>
        </div>
        <% } else { %>
        <p class="wsheet__empty"><%= _lcs( 'Für die nächsten Stunden liegt keine Vorhersage vor.' ) %></p>
        <% } %>

      <% } else { %>

        <% if ( metrics.length ) { %>
        <!-- Today's detail -->
        <div class="section-head"><h3><%= _lcs( 'Heute im Detail' ) %></h3></div>
        <div class="wmetrics">
          <% metrics.forEach( function( m ) { %>
            <div class="wmetric">
              <i class="icon icon--<%= m.icon %> wmetric__icon"></i>
              <div class="wmetric__text">
                <div class="wmetric__value"><%= m.value %></div>
                <div class="wmetric__label"><%= m.label %></div>
              </div>
            </div>
          <% } ); %>
        </div>
        <% } %>

        <% if ( days.length ) { %>
        <div class="section-head"><h3><%= _lcs( '{count}-Tage-Vorhersage', { count: days.length } ) %></h3></div>
        <ul class="wdays">
          <% days.forEach( function( d ) { %>
            <li class="wday<%= d.isToday ? ' wday--today' : '' %>">
              <span class="wday__name">
                <span class="wday__weekday"><%= d.weekday %></span>
                <span class="wday__date"><%= d.dayMonth %></span>
              </span>
              <i class="icon icon--<%= d.icon %> wday__icon" title="<%= d.label %>"></i>
              <span class="wday__rain">
                <% if ( d.rain ) { %><i class="icon icon--umbrella"></i><%= d.rain %><% } %>
              </span>
              <span class="wday__range">
                <span class="wday__min"><%= d.min %></span>
                <span class="wday__track">
                  <span class="wday__bar" style="left: <%= d.barLeft %>%; width: <%= d.barWidth %>%;"></span>
                </span>
                <span class="wday__max"><%= d.max %></span>
              </span>
            </li>
          <% } ); %>
        </ul>
        <% } %>

      <% } %>

      <footer class="wsheet__foot">
        <% if ( regionHint ) { %>
        <p class="wsheet__note"><%= regionHint %></p>
        <% } %>
        <p class="wsheet__credit">
          <%= _lcs( 'Wetterdaten:' ) %>
          <a href="<%= attribution.url %>" target="_blank" rel="noopener noreferrer"><%= attribution.text %></a>
          (<a href="<%= attribution.licenseUrl %>" target="_blank" rel="noopener noreferrer"><%= attribution.license %></a>)
        </p>
      </footer>

    </div>
  </section>
</div>
